
import { SQLModule } from './types';

export const phase2Modules: SQLModule[] = [
  {
    id: "sql-phase2-1",
    title: "Advanced Data Manipulation",
    description: "Master advanced INSERT, UPDATE, and DELETE operations with complex conditions",
    difficulty: "intermediate",
    content: `
# Advanced Data Manipulation

## Complex INSERT Operations
Learn to insert data using various methods including subqueries and conditional logic.

## Advanced UPDATE Techniques
Master updating records with joins and conditional updates.

## Safe DELETE Operations
Understand how to safely remove data with proper constraints and validation.

## Transaction Management
Learn to use transactions to ensure data integrity during complex operations.
    `,
    order: 1,
    duration: "75 minutes",
    videoUrl: "https://www.youtube.com/embed/HXV3zeQKqGY",
    tags: ["data-manipulation", "transactions", "advanced-dml"],
    prerequisites: ["Basic SQL knowledge", "Understanding of data relationships"],
    sqlPractice: {
      task: "Create a safe update operation that modifies customer data with proper validation",
      initialSchema: `
CREATE TABLE customers (
  id INT PRIMARY KEY,
  name VARCHAR(100),
  email VARCHAR(100),
  status VARCHAR(20) DEFAULT 'ACTIVE'
);
      `,
      expectedQuery: `
UPDATE customers 
SET status = 'INACTIVE' 
WHERE email IS NULL OR email = ''
  AND status = 'ACTIVE';
      `,
      hints: [
        "Use WHERE clause to target specific records",
        "Consider data validation before updates",
        "Test with SELECT first"
      ]
    },
    quiz: {
      questions: [
        {
          id: "phase2-q1",
          question: "What is the purpose of transactions in SQL?",
          options: [
            "To speed up queries",
            "To ensure data integrity",
            "To reduce storage space",
            "To improve performance"
          ],
          correctAnswer: 1
        }
      ]
    }
  }
];
